// Никоси — trigger: «При каждой атаке этого Героя: +1 Влияния».
// Срабатывает только на ИНИЦИИРОВАННУЮ атаку Героя (не на ответный удар).

import { addInfluence } from './influence.js';

export const HERO_ID = 'deus_nikosi';

export function nikosiOnHeroAttack(state, playerIdx) {
  const p = state.players[playerIdx];
  if (!p || p.hero.id !== HERO_ID) return;
  addInfluence(state, playerIdx, 1, 'Никоси [атака Героя]');
}
